<template functional>
  <div
    v-bind="data.attrs"
    :class="['Tag', data.class, data.staticClass]"
    :style="data.style"
    v-on="listeners">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.Tag {
  background: $main;
  border: 1px solid transparent;
  border-radius: $radius;
  color: $white;
  display: inline-block;
  font-size: $h6;
  font-weight: $semibold;
  line-height: 1.75rem;
  padding: 0 0.5rem;
  text-align: center;

  // > .dot {
  //   background: $main;
  //   border-radius: $radius-round;
  //   display: inline-block;
  //   height: 0.5rem;
  //   margin-right: 0.25rem;
  //   width: 0.5rem;
  // }

  // size
  // &.xs {
  //   font-size: $h7;
  //   line-height: 0.9rem;
  //   padding: 0 0.25rem;
  // }
  &.sm {
    font-size: $h6;
    line-height: 1rem;
    padding: 0.25rem 0.5rem;
  }

  &.lg {
    font-size: $h5;

    // > .dot {
    //   height: 0.75rem;
    //   width: 0.75rem;
    // }
  }

  // theme
  &.inv {
    background: transparent;
    border-color: $main;
    color: $main;
  }

  &.danger {
    background: $danger;
    border-color: $danger;

    &.inv {
      background: transparent;
      color: $danger;
    }

    &.light {
      background: $danger-lighter;
      border-color: $danger-light;
      color: $danger;
    }
  }

  &.fancy {
    background: $fancy;
    border-color: $fancy;

    &.inv {
      background: transparent;
      color: $fancy;
    }

    &.light {
      background: $fancy-lighter;
      border-color: $fancy-light;
      color: $fancy;
    }
  }

  &.info {
    background: $info;
    border-color: $info;

    &.inv {
      background: transparent;
      color: $info;
    }

    &.light {
      background: $main-lighter;
      border-color: $main-light;
      color: $main;
    }
  }

  &.neutral {
    background: $neutral;
    border-color: $neutral;

    &.inv {
      background: transparent;
      color: $text-color;
    }

    &.light {
      background: $neutral-lighter;
      border-color: $neutral-light;
      color: $neutral;
    }

  }

  &.success {
    background: $success;
    border-color: $success;

    &.inv {
      background: transparent;
      color: $success;
    }

    &.light {
      background: $success-lighter;
      border-color: $success-light;
      color: $success;
    }
  }

  &.warning {
    background: $warning;
    border-color: $warning;

    &.inv {
      background: transparent;
      color: $warning;
    }

    &.light {
      background: $warning-lighter;
      border-color: $warning-light;
      color: $warning-dark;
    }
  }

  &.noBorder {
    border: 0;
  }

  // shape
  &.round {
    border-radius: $radius-round;
    height: 1.5rem;
    line-height: 1.5rem;
    width: 1.5rem;
  }
}
</style>
